import Step1 from './Step-1'
import Step2 from './Step-2'
import Step3 from './Step-3'

export default {
  '1': Step1,
  '2': Step2,
  '3': Step3,
}
